import React, { useContext, useState, useEffect, useRef } from "react";
import { Badge, Box, Menu, MenuItem, Grid, IconButton, Typography } from "@mui/material";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import moment from "moment";
import NotificationIcon from "./NotificationIcon";
import { useNavigate } from "react-router-dom";
import bkstApi from "../../common/component/api";
import { Link as RouterLink } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import ConfigContext from "../../common/component/context/ConfigContext";

const menuId = "notif";
export default function Notifications(props) {
  const navigate = useNavigate();
  const ctx = useContext(ConfigContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [notifications, setNotifications] = useState([]);

  const isMenuOpen = Boolean(anchorEl);

  const menuRef = useRef(anchorEl);
  menuRef.current = anchorEl;

  useEffect(() => {
    const q = query(collection(db, `notification`), where("uid", "==", "j2tO1dfIh9ZnUnb40p4lK60gXaI2"), where("status", "==", "open"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const data = [];
      querySnapshot.forEach((doc) => {
        let o = doc.data();
        o.id = doc.id;
        data.push(o);
      });

      setNotifications(data.sort(sort));
    });
  }, []);

  const sort = (o1, o2) => {
    if (o1.priority > o2.priority) {
      return 1;
    } else if (o1.priority < o2.priority) {
      return -1;
    } else {
      return o1.link.localeCompare(o2.link);
    }
  };

  const clearNotification = (e, id) => {
    e.stopPropagation();
    e.preventDefault();

    bkstApi.put(`/my/notification/${id}/mark-read`);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <span>
      <IconButton onClick={handleProfileMenuOpen}>
        <Badge badgeContent={notifications.length} color="error">
          <NotificationsActiveOutlinedIcon />
        </Badge>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        id={menuId}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <Box pl={2} py={1} sx={{ borderBottom: "1px solid #DDD", marginBottom: "1em" }}>
          <Typography variant="h6">Unread Notifications</Typography>
        </Box>
        {notifications.length === 0 && (
          <MenuItem onClick={handleMenuClose} sx={{ color: "#1abc9c", justifyContent: "center" }}>
            <Box align="center" mt={1} mb={3}>
              <CheckCircleOutlineOutlinedIcon style={{ fontSize: "3rem" }} />
              <Typography>Nothing Unread</Typography>
            </Box>
          </MenuItem>
        )}
        {notifications.map((item) => (
          <MenuItem key={item.id} component={RouterLink} to={item.link} sx={{ paddingRight: "0px" }}>
            <Box sx={{ display: "flex", gap: "10px", width: "100%" }}>
              <Box pt={0.5}>
                <Badge badgeContent={item.count} color="secondary" overlap="circular">
                  <NotificationIcon type={item.heading} priority={item.priority} acctId={item.acctId} />
                </Badge>
              </Box>
              <Box sx={{ width: "170px", overflow: "hidden" }} onClick={handleMenuClose}>
                <Typography variant="body2">{item.heading}</Typography>
                <Typography
                  title={item.text}
                  variant="body2"
                  color="textSecondary"
                  style={{
                    whiteSpace: "normal",
                    display: "-webkit-box",
                    "-webkit-line-clamp": "3",
                    "-webkit-box-orient": "vertical",
                    overflow: "hidden"
                  }}
                >
                  {item.text}
                </Typography>
                <Box mt={0.5} style={{ fontSize: ".8rem", color: "#888" }}>
                  <Grid container alignItems="center">
                    <Grid item>
                      <AccessTimeOutlinedIcon style={{ fontSize: "14px", marginRight: "5px" }} />
                    </Grid>
                    <Grid item>{`${moment(item.ts.seconds * 1000).fromNow()}`}</Grid>
                  </Grid>
                </Box>
              </Box>
              <Box>
                <IconButton onClick={(e) => clearNotification(e, item.id)}>
                  <CloseIcon sx={{ color: "#999", fontSize: "16px" }} />
                </IconButton>
              </Box>
            </Box>
          </MenuItem>
        ))}
        <MenuItem component={RouterLink} to="/notifications" onClick={handleMenuClose} sx={{ borderTop: "1px solid #DDD", justifyContent: "center" }}>
          <Typography variant="overline">see all notifications</Typography>
        </MenuItem>
      </Menu>
    </span>
  );
}
